module.exports = __webpack_public_path__ + "img/content_app-einladung.38d0e303.svg";